import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Icon } from "./Icon";
import { SERVICES, CARGO_TYPES, WHY_US } from "../data/content";

export const ServicesGrid = () => (
  <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-testid="services-grid">
    {SERVICES.map((s) => (
      <Link key={s.id} to={`/services#${s.id}`} className="panel lift p-7 flex flex-col group" data-testid={`service-card-${s.id}`}>
        <div className="flex items-start justify-between">
          <span className="w-12 h-12 grid place-items-center bg-amber-500/10 border border-amber-500/30 text-brand-600"><Icon name={s.icon} className="w-6 h-6" /></span>
          <ArrowUpRight className="w-5 h-5 text-slate-500 group-hover:text-brand-600 transition-colors" />
        </div>
        <h3 className="mt-6 font-display font-bold uppercase text-slate-900 text-2xl tracking-wide">{s.title}</h3>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.short}</p>
      </Link>
    ))}
  </div>
);

export const CargoTypes = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-slate-200 border border-slate-200" data-testid="cargo-types">
    {CARGO_TYPES.map((c) => (
      <div key={c.label} className="bg-white p-6 group hover:bg-slate-100 transition-colors" data-testid={`cargo-type-${c.icon.toLowerCase()}`}>
        <Icon name={c.icon} className="w-8 h-8 text-orange-600 group-hover:scale-110 transition-transform" />
        <div className="mt-5 font-display font-bold uppercase text-slate-900 tracking-wide text-lg leading-tight">{c.label}</div>
        <div className="mt-1 text-xs text-slate-500">{c.note}</div>
      </div>
    ))}
  </div>
);

export const WhyUs = () => (
  <div className="grid sm:grid-cols-2 gap-x-10 gap-y-10" data-testid="why-us">
    {WHY_US.map((w) => (
      <div key={w.title} className="flex gap-5">
        <span className="w-11 h-11 shrink-0 grid place-items-center border border-amber-500/40 text-brand-600"><Icon name={w.icon} /></span>
        <div>
          <h3 className="font-display font-bold uppercase text-slate-900 text-xl tracking-wide">{w.title}</h3>
          <p className="mt-2 text-sm text-slate-600 leading-relaxed">{w.body}</p>
        </div>
      </div>
    ))}
  </div>
);
